/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import OrderDetails from './order-details';
import OrderDetailsView from './order-details.view';

export * from './components';
export * from './order-details';
export * from './order-details.data';
export { IOrderDetailsConfig, IOrderDetailsProps, IOrderDetailsResources } from './order-details.props.autogenerated';
export * from './order-details.view';

export {
    OrderDetails,
    OrderDetailsView
};
